(ns dre.widgets.data-sources.events
  (:require
   [dre.fx :as-alias dre.fx]
   [clojure.string :as str]
   [dre.i18n.utils :as i18n-utils]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [dre.pages.search.events :as search-events]
   [dre.utils.query :as query]
   [dre.utils :refer [stringify-keys-with-namespaces aborted-request?]]
   [dre.shared.interface.names :refer [categories]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))


(def db-path [:widgets :data-sources])

(def id
  :data-sources)

;; -- Events

(rf/reg-event-fx
 ::set-loading
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} _]
  {:db (assoc db :state :loading)}))

(rf/reg-event-fx
  ::init
  [(rf/path db-path) rf/trim-v]
  (fn
    [{db :db} [{:keys [after-fx last-selected-filter-key pills-api-params-fn]}]]
    (if (= last-selected-filter-key id) 
     {:db (assoc db :state nil)
      :dispatch after-fx}
     (let [params
          (-> (pills-api-params-fn [id])
              (assoc :query/field :published))]
      {:db {:state :loading}
       ::network/request-with-abort [{:endpoint :widgets/data-sources}
                                     {:body (stringify-keys-with-namespaces params)
                                      :on-success [::success {:after-fx after-fx}]
                                      :on-failure [::failure {:after-fx after-fx}]}]}))))


(rf/reg-event-fx
  ::success
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [_ [{:keys [after-fx ::fetch-fx/response]}]]
    {:db {:state :success
          :data (:body response)}
     :dispatch after-fx}))


(rf/reg-event-fx
  ::failure
  [(rf/path db-path) rf/trim-v]
  (fn-traced
    [_ [{:keys [after-fx ::fetch-fx/response] :as opts}]]
    (if (aborted-request? response)
      {}
      {:db {:state :failure
            :data nil}
       :dispatch-n [after-fx
                    [:dre.network/default-failure (merge {:event :data-sources} opts)]]})))

(rf/reg-event-fx
 ::export
 [rf/trim-v]
 (fn-traced
  [{root-db :db} _]
  (let [db (get-in root-db db-path)
        i18n-db (:i18n root-db)
        data (:data db)
        data (:search/count data)
        data (sort-by :count > data)
        data (map #(assoc % :label (or (get categories (:term %))
                                       (str/capitalize (:term %))))
                  data)
        csv-lines (map (fn [{:keys [:label :count]}]
                         (str (pr-str label) "," count))
                       data)
        header (str (i18n-utils/translate i18n-db "Data source") "," (i18n-utils/translate i18n-db "Count"))
        csv (str/join "\n" (cons header
                                 csv-lines))]
    (rf/dispatch [::dre.fx/download {:content csv
                                     :filename "data-sources.csv"
                                     :mimetype "text/csv"}])
    nil)))


;; -- Subscriptions

(rf/reg-sub
  ::state
  (fn [db _]
    (get-in db db-path)))

(defn ->pill
  [term]
  {:pill/type :category
   :pill/query term})

(defn prepare-data
  [data f filter-key]
  (let [click (fn [term]
                #(rf/dispatch [::search-events/widget-filter-select
                               filter-key (->pill term)]))]
    (map (fn [{:keys [count term]}]
           (hash-map :label (get categories term (str/capitalize term))
                     :term term
                     :class [(when (seq f) (if (contains? f (->pill term)) "active" "inactive"))]
                     :on-click (click term)
                     :count count))
         data)))

(rf/reg-sub
 ::data
 :<- [::state]
 :<- [::search-events/widget-filters]
 (fn [[state widget-filters] _]
   (let [filter-key id
         f (get widget-filters filter-key)
         data (:data state) 
         count-data (:search/count data)
         result (prepare-data count-data f filter-key)]
     result)))

(rf/reg-sub
 ::total-count
 :<- [::state]
 (fn [state _]
   (get-in state [:data :search/total-count])))

(rf/reg-sub
  ::status
  :<- [::state]
  (fn [db _]
    (:state db)))

;; 
(defn- data-sources-pill?
  [{:pill/keys [type]}]
  (= type :category))

(defn data-sources-filters
  [db]
  (->> db
       search-events/db-path
       :widget-filters
       id
       (filter data-sources-pill?)))

(defn data-sources-queries
  [db]
  (->> db
       search-events/db-path
       :search-query
       :query/pills
       (filter data-sources-pill?)))

(defn selected-data-source?
  [db]
  (let [x (concat (data-sources-filters db) (data-sources-queries db))]
    (not-empty x)))

(rf/reg-sub
 ::used-in-search?
 selected-data-source?)